module.exports = __webpack_public_path__ + "static/media/norutec_20_14.ab3ab88c.png";